<ng-template #templateMaisDetalhes>
    <div class="mais-detalhes" [ngClass]="{ 'modal-overlap': overlapModal }">
        <div class="modal-header d-flex flex-wrap">
            <div class="modal-title">
                <div title="{{purchaseAreaBaseData.brandName}}" class="col-md-1 rounded-circle marca {{purchaseAreaBaseData.brandName}}"></div>
                <p><span class="truncate">{{cotacaoSelecionada?.vehicle_formatted}}</span></p>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="fecharModal();"></button>
        </div>
        <div class="modal-body">
            <ng-scrollbar>
                @if (!modal_visivel.comentarios) {
                    <div class="d-flex flex-wrap body detalhes" >
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.codigo' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="pdetalhes">#{{cotacaoSelecionada?.id}}</span>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.criada-em' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="pdetalhes">
                                    {{purchaseAreaBaseData.updateDate}}
                                    @if (purchaseAreaBaseData.updateDate != purchaseAreaBaseData.creationDate) {
                                        <small> ({{purchaseAreaBaseData.creationDate}})</small>
                                    }
                                </span>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.data-entrada-em' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="pdetalhes">{{purchaseAreaBaseData.dataEntradaOficina}}</span>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.chassi' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="pdetalhes">{{cotacaoSelecionada?.chassi}}</span>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.seguradora' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="pdetalhes">{{purchaseAreaBaseData.insuranceName}}</span>
                            </div>
                        </div>
                        @if (purchaseAreaBaseData.buyerNotes) {
                            <div class="linha">
                                <div class="col">
                                    <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.obs-comprador' | translate}}:</label>
                                </div>
                                <div class="col col-3">
                                    <span class="pdetalhes">{{purchaseAreaBaseData.buyerNotes}}</span>
                                </div>
                            </div>
                        }
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.pecas' | translate}}:</label>
                            </div>
                            <div class="col-3 lista-pecas">
                                @for (peca of cotacaoSelecionada?.itens; track peca; let i = $index) {
                                    <div class="row" style="width: 550px;">
                                        <div class="col-md-11 alterar-peca truncate" style="width: 480px;" (click)="modal_editar_peca_abrir($event, peca)">
                                            ({{peca.quantity}}) {{peca.partTypeInfo}}{{peca.nameWithCode}}
                                        </div>
                                        @if ((this.userService.userIsCentral())) {
                                            <i class="col-md-1 fa fa-trash" style="cursor: pointer; float: right;" (click)="modal_editar_peca_remover($event, peca, i)"></i>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="linha upload-imagem">
                            <div class="col label-info text-center">
                                <span class="text-white">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.limite-upload' | translate}}</span>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.fotos.titulo' | translate}}:</label>
                            </div>
                            <div class="col col-3">
                                <span class="btn btn-light btn-file" [ngClass]="{disabled:cotacaoSelecionada?.fotos.length >= maxUploadImages}">
                                    {{'buyer.cotacao.area-comprar.modal-mais-detalhes.fotos.selecione' | translate}}
                                    <input type="file" id="novaFoto" accept="image/*" (change)="uploadImages()"    [disabled]="cotacaoSelecionada?.fotos.length >= maxUploadImages ? 'disabled' : null" multiple>
                                </span>
                            </div>
                        </div>
                        <div class="linha fotos">
                            <div class="col">
                                @for (img of cotacaoSelecionada?.fotos; track img) {
                                    <div>
                                        <img class="image-to-zoom" src="{{img.file}}" (click)="zoomImage(img.file)"/>
                                        <i class="fa fa-remove fa-1x" (click)="excluirFoto(img.file)"></i>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="d-flex flex-wrap body comentarios">
                        <div class="linha">
                            <div class="col cabecalho">
                                <label class="col-form-label">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.comentarios.titulo' | translate}}:</label>
                            </div>
                        </div>
                        <div class="linha">
                            <div class="col-5">
                                <textarea class="form-control" [(ngModel)]="novo_comentario"></textarea>
                            </div>
                            <div class="col">
                                <button type="button" class="btn btn-primary" (click)="modal_comentarios_salvar()">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.comentarios.botao-adicionar' | translate}}</button>
                            </div>
                        </div>
                        <div class="lista-comentarios">
                            @for (item of areaComprarComentarios; track item) {
                                <div class="linha-comentario">
                                    <div class="linha">
                                        <div class="col">
                                            <label>{{ item.usuario.nome }} [{{item.data | date:'dd/MM/yyyy HH:mm'}}]</label>
                                        </div>
                                    </div>
                                    <div class="linha">
                                        <div class="col">
                                            <span>{{item.comentario}}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </ng-scrollbar>
        </div>
        <div class="modal-footer">
            <button class="update-part-type-quotation-button" customButton styleType="secondary" label="buyer.cotacao.area-comprar.modal-mais-detalhes.edit-part-type-quotation" iconName="edit" [isLoading]="false" (click)="openEditPartTypeQuotationModal()"></button>

            @if ((this.userService.userIsCentral()) && !modal_visivel.comentarios) {
                <button type="button" class="btn btn-outline-primary" (click)="modal_comentarios_abrir()">{{'buyer.cotacao.area-comprar.modal-mais-detalhes.comentarios.botao-ver' | translate}}</button>
            }

            @if (!modal_visivel.comentarios) {
                <button type="button" class="btn btn-light" (click)="fecharModal()">{{'elemento.generico-botao.fechar' | translate}}</button>
            }

            @if ((this.userService.userIsCentral()) && modal_visivel.comentarios) {
                <button type="button" class="btn btn-light" (click)="modal_comentarios_fechar()">{{'elemento.generico-botao.voltar' | translate}}</button>
            }
        </div>

        <ngx-loading [show]="loading_adicionar_foto"></ngx-loading>
    </div>

    <app-editar-peca [peca]="pecaSelecionada" [visivel]="modal_visivel.editar_peca" (fechar)="modal_editar_peca_fechar($event)"></app-editar-peca>
    <app-editar-part-type-cotacao #editPartTypeQuotation  [quotationId]="cotacaoSelecionada.id" (onClose)="onCloseEditPartTypeQuotationModal()" (updateQuotation)="updateQuotation()"></app-editar-part-type-cotacao>
</ng-template>
